import { css } from 'emotion';
import {
  tabletPortraitMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const mapStyle = css({
  width: '100%',
  height: '686px',
  position: 'relative',
  marginBottom: '25px',
  [`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
    height: '100%',
    marginBottom: 0,
    position: 'absolute',
    top: '0',
    left: '0',
  },
});



// WEBPACK FOOTER //
// ./src/components/treatment-services/map/styles.js